import { Outlet, useLocation } from "react-router-dom"
import Toaster from "../../components/ui/Toaster"
import { Box } from "@mui/material"
import { useEffect } from "react"
import DialogContainer from "../../components/Dialog"

function Layout() {
  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
  }, [pathname])

  return (
    <Box
      sx={{
        display: "grid",
        minHeight: "100vh",
        gridTemplateRows: "1fr"
      }}
    >
      <Box component="main" maxWidth={{ xs: "100vw", md: "calc(100vw - 17px)" }}>
        <Outlet />
      </Box>
      <Toaster />
      <DialogContainer />
    </Box>
  )
}

export default Layout